import {
  ClassifierFormDataType,
  ClassifierOverviewDto,
  getDatePeriodString,
} from '@atlas-frontend/sdk';

// DTO -> directory values
export const convertToClassifiersDataSource = ({
  validFrom,
  validTo,
  categoryCount,
  groupCount,
  hasCategories,
  ...classifier
}: ClassifierOverviewDto) => ({
  ...classifier,
  key: classifier.id,
  categoryCount: hasCategories ? categoryCount : null,
  groupCount: hasCategories ? groupCount : null,
  validPeriod: getDatePeriodString(validFrom, validTo),
});

type CategoryFormData = ClassifierFormDataType['categories'][number];

const clearCategoryIds = (category: CategoryFormData): CategoryFormData => ({
  ...category,
  id: null,
  categoryRelations: category.categoryRelations.map((relation) => ({
    ...relation,
    id: null,
  })),
});

// Existing classifier -> clone form values.
// Clone must not reference the original's DB rows, otherwise backend treats it as an update
export const convertToCloneFormData = (
  classifier: ClassifierFormDataType,
): ClassifierFormDataType => ({
  ...classifier,
  id: null,
  code: '',
  categories: classifier.categories.map(clearCategoryIds),
  categoryGroups: classifier.categoryGroups.map(clearCategoryIds),
  combinedGroups: classifier.combinedGroups.map(clearCategoryIds),
});
